export const PRIMARY_COLOR = "#FCFCFC";
export const SECONDARY_COLOR = "#121212";
export const ACCENT_COLOR = "#0a84ff";

export const COLORS = {
    red: "#ff453a",
    orange: "rgba(255, 159, 10, 1)",
    yellow: "rgba(255, 214, 10, 1)",
    green: "rgba(50, 215, 75, 1)",
    mint: "rgba(102, 212, 207, 1)",
    teal: "rgba(106, 196, 220, 1)",
    cyan: "rgba(90, 200, 245, 1)",
    blue: "rgba(10, 132, 255, 1)",
    indigo: "rgba(94, 92, 230, 1)",
    purple: "rgba(191, 90, 242, 1)",
    pink: "rgba(255, 55, 95, 1)",
    brown: "rgba(172, 142, 104, 1)",
    gray: "rgba(152, 152, 157, 1)",
    black: "rgba(0, 0, 0, 1)",
    white: "rgba(254, 254, 254, 1)",
};
